<!-- <input type="radio" /> -->

<mat-radio-group [formControl]="$any(control)">
  @for (v of values; track v) {
    <mat-radio-button [name]="v" [value]="v">
      {{ v }}
    </mat-radio-button>
  }
</mat-radio-group>
<!-- <label>{{ text }}</label> -->
@if (useQuestion) {
  <img src="/circle-question.svg" />
}
